import { DropAreaPoint } from "../types/DropAreaPoint";

export function cloneDropAreaPoints(dropAreaPoints: DropAreaPoint[]) {
	return [...dropAreaPoints.map((point) => ({ ...point }))];
}
